export { EducationChip } from './EducationChip';
